import { faCircleCheck, faCircleDashed, faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import * as style from './style.module.css';

const Msg = ({ title, text, icon }) => (
    <div>
        <div className={style.titleContainer}>
            <span className={style.icon}>{icon}</span>
            <div className={style.textContainer}>
                <Typography color="neutral-primary" fontWeight="medium" fontSize="m">
                    {title}
                </Typography>
                <Typography color="neutral-secondary" fontWeight="regular" fontSize="m">
                    {text}
                </Typography>
            </div>
        </div>
    </div>
);

export function showToast({ text = 'Default text', title = 'Default title', type = 'primary' } = {}) {
    const getIcon = () => {
        switch (type) {
            case 'success':
                return <FontAwesomeIcon icon={faCircleCheck} className={`${style.icon} ${style[type]}`} />;
            case 'error':
                return <FontAwesomeIcon icon={faCircleExclamation} className={`${style.icon} ${style[type]}`} />;
            case 'warning':
                return <FontAwesomeIcon icon={faCircleExclamation} className={`${style.icon} ${style[type]}`} />;
            default:
                return <FontAwesomeIcon icon={faCircleDashed} className={`${style.icon} ${style[type]}`} />;
        }
    };

    // Appeler directement le toast
    return toast(<Msg text={text} title={title} icon={getIcon()} />, {
        position: 'top-right',
        theme: 'colored',
        type: type,
        icon: false,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        newestOnTop: false,
        progress: undefined,
    });
}
